type MapFunc<T> = (val: T, index?: number, arr?: T[]) => string

export const groupBy = <T>(arr: T[], fn: MapFunc<T> | (keyof T & string)): Record<string, undefined | T[]> =>
	arr.map(typeof fn === 'string' ? (val: T) => String(val[fn] ?? '') : fn).reduce(
		(acc, val, i) => {
			acc[val] = (acc[val] || []).concat(arr[i])
			return acc
		},
		{} as Record<string, undefined | T[]>,
	)
